var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareFacebook = function SvgShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v48h25.436V32.136h-6.153v-7.355h6.153v-5.657c0-6.548 4.204-10.185 9.903-10.185 2.73 0 5.077.21 5.76.301l.002 7.054-3.956-.21c-3.098 0-3.877 1.39-3.877 3.605v5.092h7.275l-.561 7.355h-6.714V48H48V0H0z"
  }))));
};
export default SvgShareFacebook;